
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 91 90","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.074 12.225c.45-1.381 2.403-1.381 2.852 0l5.903 18.138a4.5 4.5 0 004.28 3.107h19.09c1.454 0 2.058 1.86.881 2.714L61.643 47.382a4.5 4.5 0 00-1.637 5.035l5.899 18.124c.45 1.381-1.131 2.531-2.307 1.678L48.142 61.01a4.5 4.5 0 00-5.284 0l-15.456 11.21c-1.176.853-2.756-.297-2.307-1.678l5.899-18.124a4.5 4.5 0 00-1.637-5.035L13.92 36.184c-1.177-.853-.573-2.714.88-2.714h19.092a4.5 4.5 0 004.279-3.107l5.903-18.138z","stroke":"#EDC843","stroke-width":"3"}})])
          )
        }
      }
    